import { api } from "../lib/axios";

import type { VectorChunkingMethod, VectorEmbeddingModel, VectorMetadata } from "../types/vector";
import type { ApiData } from "./apiData";

interface NamespaceFile {
	id: string // uuid
    fileName: string
	fileUrl: string
	chunkingMethod: VectorChunkingMethod
	metadatas: Array<VectorMetadata>
}

interface Namespace {
    id: string
    name: string
    files: Array<NamespaceFile>
    embeddingModelName: VectorEmbeddingModel
};

interface GetMeResponseData {
    id: string
    name: string
    email: string
    customerId: string
    /*
    defaultPaymentMethod: 
    registrationMethod:
    */
    firstTimeLogin: boolean
    /*
    avatar: string | null
    cover: 
    theme:
    apiKey:
    chatFlowId:
    googleAccessToken:
    googleRefreshToken:
    hubspotAccessToken:
    hubspotRefreshToken:
    chatsId: Array<>
    */
    namespaces: Array<Namespace>
    /*
    objects: Array<>
    voice: Array<>
    backgroundColor:
    socketId:
    tabs: Array<>
    assistants: Array<>
    tabfiliateReferralCode:
    trialTokens:
    */
    hasFinishedOnboarding: boolean
    /*
    dashboardBackground:
    selectedCompanyId:
    */
    transferData: boolean
    companyUserHasFinishedOnboarding: boolean
    /*
    invitedAs:
    userConfig: Array<>
    lastCompanyLogin:
    plan:
    tokenPurchaseRate:
    fluxTokenPrice:
    totalTokens:
    spentTokens:
    freeTokens:
    */
    isUserCompany: boolean
    /*
    numberOfFlows:
    selectedCompanyName:
    */
    showTokens: boolean
    /*
    companyRole:
    */
};

type GetMeResponse = ApiData<GetMeResponseData>

async function getMe() {
    const response = await api.get<GetMeResponse>('/auth/me');

    return response.data.data;
}

export { getMe, type GetMeResponse };